import * as React from 'react'
import { Box, SxProps } from '@mui/material'
import { useAnimationStyles } from 'src/Libs/live-view'
import EnergyFlowIndicatorSvg from './EnergyFlowIndicatorSvg'

export interface ArrowSvgProps {
  transform: string
  direction?: 'in' | 'out'
  doRotateBy180Deg?: boolean
  sx?: SxProps
}

const CurvedArrowLongSvg: React.FC<ArrowSvgProps> = ({ direction, transform, doRotateBy180Deg = false, sx }) => {
  const { classes, cx } = useAnimationStyles({ direction })

  return (
    <Box sx={{ position: 'relative', transform, ...sx }}>
      <svg width={69} height={81} viewBox="0 0 69 81" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="livevalue_arrow_curved">
          <g id="line">
            <path id="line_2" d="M61.5 77.5V22.5C61.5 14.2157 54.7843 7.5 46.5 7.5H1.5" stroke="#A4AAAE" strokeWidth={2} strokeLinecap="round" />
          </g>
          {direction === 'out' && (
            <g id="arrow_out">
              <path
                d="M54.2928 73.7085L54.2245 73.6332C53.9039 73.2404 53.9267 72.6604 54.2928 72.2943C54.659 71.9281 55.239 71.9054 55.6318 72.2259L55.707 72.2943L62.2057 78.7929C62.5962 79.1834 62.5962 79.8166 62.2057 80.2071C61.8151 80.5976 61.182 80.5976 60.7914 80.2071L54.2928 73.7085Z"
                fill="#A4AAAE"
              />
              <path
                d="M67.2935 72.293L67.3695 72.224C67.7623 71.9038 68.3417 71.927 68.7078 72.293C69.0983 72.6836 69.0983 73.3167 68.7078 73.7072L62.2078 80.2072C61.8172 80.5978 61.1841 80.5978 60.7936 80.2072C60.403 79.8167 60.403 79.1835 60.7936 78.793L67.2935 72.293Z"
                fill="#A4AAAE"
              />
            </g>
          )}
          {direction === 'in' && (
            <g id="arrow_in">
              <path
                d="M6.79165 0.292834L6.86692 0.224471C7.2597 -0.0960655 7.83968 -0.0733497 8.20586 0.292834C8.57205 0.659018 8.59476 1.239 8.27423 1.63178L8.20586 1.70705L1.70725 8.20566C1.31672 8.59619 0.683558 8.59619 0.293034 8.20566C-0.0974901 7.81514 -0.0974901 7.18197 0.293034 6.79145L6.79165 0.292834Z"
                fill="#A4AAAE"
              />
              <path
                d="M8.20709 13.2935L8.27615 13.3695C8.59633 13.7623 8.57315 14.3417 8.20709 14.7078C7.81657 15.0983 7.18341 15.0983 6.79288 14.7078L0.292884 8.20777C-0.0976399 7.81724 -0.0976406 7.18408 0.292884 6.79355C0.683408 6.40303 1.31657 6.40303 1.7071 6.79355L8.20709 13.2935Z"
                fill="#A4AAAE"
              />
            </g>
          )}
        </g>
      </svg>
      {!!direction && (
        <EnergyFlowIndicatorSvg
          className={cx(classes.directionIndicator, classes.curvedArrowAnimation)}
          doRotateBy180Deg={doRotateBy180Deg}
          direction={direction}
        />
      )}
    </Box>
  )
}

export default CurvedArrowLongSvg
